import React, { useState } from "react";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CardBody,
  Col,
} from "reactstrap";

const AggregateResourceCarousel = ({ resources = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === resources.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const prevIndex =
      activeIndex === 0 ? resources.length - 1 : activeIndex - 1;
    setActiveIndex(prevIndex);
  };

  const slides = resources.map((resource, index) => (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={index}
    >
      <div>
        <CardBody className="text-center mb-2 d-flex justify-content-center align-items-center">
          <Col className="mb-3 d-flex flex-column align-items-center">
            <div
              className="fs-3 fw-bold text-center"
              style={{ color: "white" }}
            >
              <span>{resource.resourceName}</span>
            </div>
            <div className="mt-1 text-center">
              <div className="balance-number mt-3">
                {resource.consumedBalance}
                <span className="balance-unit">{resource.uom}</span>
              </div>
            </div>
            <div
              className="fs-5 fw-normal text-center"
              style={{ color: "white" }}
            >
              Consumed
            </div>
          </Col>
        </CardBody>
      </div>
    </CarouselItem>
  ));

  return (
    resources.length > 0 && (
      <div className="white-carousel-arrows">
        <Carousel activeIndex={activeIndex} next={next} previous={previous}>
          {slides}
          {resources.length > 1 && (
            <>
              <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={previous}
              />
              <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={next}
              />
            </>
          )}
        </Carousel>
        <style jsx>{`
          .white-carousel-arrows .carousel-control-prev-icon,
          .white-carousel-arrows .carousel-control-next-icon {
            filter: invert(1);
          }
        `}</style>
      </div>
    )
  );
};

export default AggregateResourceCarousel;
